module.exports = __webpack_public_path__ + "img/logo-full-horizontal-cropped-1200.14ffd4a5.png";